import { render, staticRenderFns } from "./TicketDynamicTab.vue?vue&type=template&id=b4be8d20&scoped=true&"
import script from "./TicketDynamicTab.vue?vue&type=script&lang=js&"
export * from "./TicketDynamicTab.vue?vue&type=script&lang=js&"
import style0 from "./TicketDynamicTab.vue?vue&type=style&index=0&id=b4be8d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4be8d20",
  null
  
)

export default component.exports